import product from '../images/product-2.png'
import inventory from '../images/inventory-1.jpg'
import snake from '../images/snake.png'
import expense from '../images/expense.jpg'

export const Project_data=[
    {
        id:1,
        title:"Inventory",
        image:inventory,
        alt:"Inventory Image",
        description:"This is a web application built to simulate an online furniture store where products can be bought and shipped to the required address.",
        url:"https://github.com/NGiridharaHolla/Online_Shop",
        btn_title:"GitHub"
    },
     {
        id:2,
        title:"Fashion App",
        image:product,
        alt:"Fashion App Image",
        description:"A mobile and web application built to simulate an e-commerce application where trendy fashion accessories can be bought.",
        url:"https://github.com/NGiridharaHolla/Fashion-App",
        btn_title:"GitHub"
    },
     {
        id:3,
        title:"Snake Game",
        image:snake,
        alt:"Snake Game Image",
        description:"A game built using Python where the player has to keep the snake alive and move on to the further levels.",
        url:"https://github.com/NGiridharaHolla/python_snake_game/tree/main/Snake_Game",
        btn_title:"GitHub"
    },
    {
        id:4,
        title:"Expense Tracker",
        image:expense,
        description:"A simple and easy to use web application that keeps track of the users expenses, thus simplifying the user's basic finances.",
        // url:"https://github.com/NGiridharaHolla/Expense-Tracker"
        url:"https://outgo-tracker.netlify.app",
        btn_title:"View"
    }
]